import Button from '@viking-eng/button';
import CancelCircle from '@viking-eng/icon/lib/CancelCircle';
import PropTypes from '@viking-eng/prop-types';
import classNames from 'classnames';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import { isIOS } from 'react-device-detect';
import './Modal.css';

const jQuery = window.$ || $;

const modifyStyle = (open) => {
  const elements = [document.getElementsByTagName('html')[0], document.getElementsByTagName('body')[0]];
  elements.forEach((element) => {
    element.style.position = open ? 'fixed' : null; // eslint-disable-line no-param-reassign
  });
};

/*
  Resuable modal component
  children: JSX content to display inside the modal
  fade: Flag on whether to display the fade class
  hasPrint: Flag that controls whether to display the print button
  id: Id of the modal
  labelId: Id of the element that describes the modal; used for accessibility
*/
const Modal = (props) => {
  const {
    children,
    closeOnEsc,
    closeOnOverlayClick,
    disableCloseButton,
    fade,
    forceAction,
    id,
    onClose,
    labelId,
    onPrint,
    printLabel,
  } = props;

  useEffect(() => {
    const modal = jQuery(`#${id}`);
    if (isIOS) {
      let scrollX;
      let scrollY;
      modal.on('show.bs.modal', () => {
        ({ scrollX, scrollY } = window);
        modifyStyle(true);
      });

      modal.on('hide.bs.modal', () => {
        modifyStyle(false);
        window.scrollTo(scrollX, scrollY);
      });

      jQuery(document).on('orientationchange', () => {
        modal.modal('hide');
      });
    }

    modal.on('hidden.bs.modal', () => {
      onClose();
    });

    modal.on('shown.bs.modal', () => {
      jQuery(document).off('focusin.modal');
    });
  }, []);

  const [dataKeyboard, setDataKeyboard] = useState(true);

  useEffect(() => {
    if (!forceAction) {
      setDataKeyboard(true);
    }
    if (!closeOnEsc) {
      setDataKeyboard(false);
    }
  }, [forceAction, closeOnEsc]);

  return (
    <div
      aria-hidden="true"
      aria-labelledby={labelId}
      className={classNames('modal show', { fade })}
      data-backdrop={!closeOnOverlayClick || forceAction ? 'static' : undefined}
      data-keyboard={dataKeyboard}
      id={id}
      role="dialog"
      tabIndex="-1"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-controls-wrapper">
            {printLabel && onPrint && (
              <div className="print-button align-baseline">
                <Button appearance="link" onButtonClick={onPrint}>
                  {printLabel}
                </Button>
              </div>
            )}
            {!forceAction && (
              <div className="modal-controls align-baseline">
                <div className="close-button">
                  <Button
                    appearance="icon"
                    attributes={{
                      'aria-label': 'Close',
                      'data-target': disableCloseButton ? undefined : `#${id}`,
                      'data-toggle': disableCloseButton ? undefined : 'modal',
                    }}
                  >
                    <CancelCircle />
                  </Button>
                </div>
              </div>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.jsx,
  closeOnEsc: PropTypes.bool,
  closeOnOverlayClick: PropTypes.bool,
  disableCloseButton: PropTypes.bool,
  fade: PropTypes.bool,
  forceAction: PropTypes.bool,
  id: PropTypes.string.isRequired,
  labelId: PropTypes.string,
  onClose: PropTypes.func,
  onPrint: PropTypes.func,
  printLabel: PropTypes.string,
};

Modal.defaultProps = {
  children: '',
  closeOnEsc: true,
  closeOnOverlayClick: true,
  disableCloseButton: false,
  fade: false,
  forceAction: false,
  labelId: '',
  onClose: () => true,
  onPrint: () => window.print(),
  printLabel: '',
};

export default Modal;
